import React from 'react';

import Talk from '../../components/Talk';
import Layout from '../../components/Layout';

const Home = () => (
	<Layout active="home">
		<Talk className="talk" />
	</Layout>
);

export default Home;
